import {postRequest} from "../../utils/api"

export const getProductList = (params) => {
    return postRequest('/core/info/product/list',params)
}

export const addProduct = (params) => {
    return postRequest('/core/info/product/add',params)
}

export const updateProduct = (params) => {
    return postRequest('/core/info/product/update',params)
}

export const deleteProduct = (params) => {
    return postRequest('/core/info/product/delete',params)
}

export const getInfoProductFindTree = () => {
    return postRequest('/core/info/product/infoProductFindTree')
}
